import React, { useEffect, useState } from "react";
import OrdersTableInprogressTakeaway from "./OrdersTable/InPreogress/OrdersTableInprogressTakeaway";
import OrdersTableInprogressDinein from "./OrdersTable/InPreogress/OrderTableInProgressDinein";

function TableIntegration({ orderType, orderData, refresh }) {
  const [orderTakeAwayData, setOrderTakeAwayData] = useState([]);
  const [orderDineInData, setOrderDineInData] = useState([]);

  useEffect(() => {
    setOrderTakeAwayData(
      orderData.filter((order) => order.orderType === "Takeaway")
    );
    setOrderDineInData(
      orderData.filter((order) => order.orderType === "Dine-in")
    );
  }, [orderData]);

  return (
    <div className="tablesOrder">
      {orderType === "Take Away" ? (
        <OrdersTableInprogressTakeaway
          items={orderTakeAwayData}
          refresh={refresh}
        />
      ) : orderType === "Dine in" ? (
        <OrdersTableInprogressDinein
          items={orderDineInData}
          refresh={refresh}
        />
      ) : null}
    </div>
  );
}

export default TableIntegration;
